module.exports = __webpack_public_path__ + "static/media/photo99.953d1cfe.jpg";